import { useEffect, useRef } from "react"
import { useAuth } from "@clerk/clerk-react"
import useAppDispatch from "./use-app-dispatch"
import { clearTestTenant } from "../app/slices/user-slice"

export function useClearTestTenantOnAuthChange() {
    const dispatch = useAppDispatch()
    const { isSignedIn, isLoaded, userId, sessionId } = useAuth()
    const previousIdentity = useRef<string>()

    useEffect(() => {
        if (!isLoaded) return
        // Auth identifiers change together; useUser may temporarily return no user.
        if (isSignedIn && !userId) return
        const identity = JSON.stringify([isSignedIn ? userId : null, isSignedIn ? sessionId : null])

        if (previousIdentity.current !== undefined && previousIdentity.current !== identity) {
            dispatch(clearTestTenant())
        }
        previousIdentity.current = identity
    }, [isLoaded, isSignedIn, userId, sessionId, dispatch])
}
